// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__1GfiF","footer":"ModalError_footer__2LN_v"};